import info from './info.svg?sprite';
import success from './success.svg?sprite';
import warning from './warning.svg?sprite';
import arrowLeft from './arrow-left.svg?sprite';
import close from './close.svg?sprite';
import wishlist from './wishlist.svg?sprite';
import copy from './copy.svg?sprite';
import spinner from './spinner.svg?sprite';
import play from './play.svg?sprite';
import checkboxDefault from './checkbox-default.svg?sprite';
import checkboxActive from './checkbox-active.svg?sprite';
import truck from './truck.svg?sprite';
import returnCircle from './return.svg?sprite';
export default {
    info: info,
    success: success,
    warning: warning,
    arrowLeft: arrowLeft,
    wishlist: wishlist,
    close: close,
    copy: copy,
    spinner: spinner,
    play: play,
    checkboxDefault: checkboxDefault,
    checkboxActive: checkboxActive,
    truck: truck,
    returnCircle: returnCircle,
};
